import React from 'react';
import { useAuth } from '../../context/AuthContext';
import StudentManagement from './StudentManagement';
import SuperAdminStudentManagement from '../admin/SuperAdminStudentManagement';

const StudentManagementGateway = () => {
  const { user } = useAuth();

  if (user?.role === 'EXAM_SECTION') {
    return <SuperAdminStudentManagement />;
  }

  if (user?.role === 'HOD') {
    return <SuperAdminStudentManagement showActions />;
  }

  if (user?.role === 'FACULTY') {
    return <SuperAdminStudentManagement showActions={false} />;
  }

  return <StudentManagement />;
};

export default StudentManagementGateway;
